import script from "./JobRunsDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./JobRunsDetail.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__